import React from 'react'
import { Link } from 'react-router-dom'

const About = () => {
  return (
    <section className="mx-auto max-w-6xl px-4 py-6 md:py-10">
      <div className="rounded-2xl border border-orange-100/70 bg-white/90 p-8 shadow-modern backdrop-blur-sm md:p-12">
        <header className="max-w-4xl text-left">
          <p className="text-sm font-bold uppercase tracking-[0.35em] text-brand md:text-base">
            About It&apos;s Yummtime
          </p>
          <h1 className="mt-5 text-4xl font-bold leading-tight tracking-tight text-warm-charcoal md:text-5xl lg:text-6xl">
            A smarter way to discover, save, and cook recipes from around the world.
          </h1>
          <p className="mt-8 max-w-4xl text-xl leading-relaxed text-warm-gray-600">
            It&apos;s Yummtime helps home cooks find authentic dishes fast, compare key recipe
            details like ingredients and calories, and build a reliable cooking routine. From quick
            searches to Premium saved recipes, every feature is designed to make everyday meal
            decisions easier and more confident.
          </p>
        </header>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          <article className="rounded-2xl bg-orange-50/65 p-7 shadow-sm">
            <h2 className="text-3xl font-semibold tracking-tight text-warm-charcoal">
              For Global Discovery
            </h2>
            <p className="mt-4 text-xl leading-relaxed text-warm-gray-700">
              Explore a wide mix of cuisines and uncover dishes that bring global flavors into your
              kitchen with authentic inspiration.
            </p>
          </article>

          <article className="rounded-2xl bg-orange-50/65 p-7 shadow-sm">
            <h2 className="text-3xl font-semibold tracking-tight text-warm-charcoal">
              For Everyday Cooking
            </h2>
            <p className="mt-4 text-xl leading-relaxed text-warm-gray-700">
              Search recipes in seconds, review ingredients clearly, and move from idea to meal
              without getting stuck in long browsing sessions.
            </p>
          </article>

          <article className="rounded-2xl bg-orange-50/65 p-7 shadow-sm">
            <h2 className="text-3xl font-semibold tracking-tight text-warm-charcoal">
              For Better Decisions
            </h2>
            <p className="mt-4 text-xl leading-relaxed text-warm-gray-700">
              Use calorie visibility and Premium saved recipes to repeat your best finds, plan
              smarter meals, and cook with confidence.
            </p>
          </article>
        </div>

        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="nav-get-started-lines inline-flex h-14 items-center justify-center rounded-xl bg-gradient-to-r from-orange-500 to-orange-600 px-8 text-2xl font-semibold text-white shadow-modern transition-all duration-300 hover:-translate-y-0.5 hover:from-orange-600 hover:to-orange-700 hover:shadow-glow"
          >
            <span className="relative z-10">Discover Global Flavors</span>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default About
